import React, { useState } from "react";
import StripeForm from "components/payments/StripeForm";
import LcFetch from "lib/shared/fetch";

export function UpdateCardForm(props) {
  const { returnUrl, requests, StripePaymentElement, subscriptionType } = props;
  const [errorMessage, setErrorMessage] = useState();
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const handleReady = (_element) => {
    setDisabled(false);
  };

  const handleError = (result) => {
    setErrorMessage(result.error.message);
    setLoading(false);
    setDisabled(false);
  };

  const handleSubmit = () => {
    setLoading(true);
    setDisabled(true);
    return true;
  };

  const handleSuccess = (result) => {
    const { id } = result.setupIntent;
    const params = {
      billing: {
        setup_intent_id: id
      }
    };

    requests
      .updateCard(params)
      .then((response) => response.json())
      .then((data) => {
        window.location.assign(data.redirect_to);
      })
      .catch((error) => {
        console.error(error);
        setErrorMessage("Something went wrong. Please try again.");
        setLoading(false);
        setDisabled(false);
      });
  };

  const formButtons = () => (
    <FormButtons disabled={disabled} loading={loading} />
  );

  return (
    <div id="update-card-form">
      <div className="modal-body">
        <StripeForm
          isPaymentIntent={false}
          onReady={handleReady}
          onError={handleError}
          onSubmission={handleSubmit}
          onSuccess={handleSuccess}
          FormButtons={formButtons}
          returnUrl={returnUrl}
          errorMessage={errorMessage}
          StripePaymentElement={StripePaymentElement}
          subscriptionType={subscriptionType}
        />
      </div>
    </div>
  );
}

const requests = {
  updateCard: (params) =>
    LcFetch("/account", {
      body: JSON.stringify(params),
      headers: {
        "Content-Type": "application/json"
      },
      method: "PUT"
    })
};

export default function (props) {
  return (
    <UpdateCardForm
      requests={requests}
      StripePaymentElement={props.StripePaymentElement}
      returnUrl={props.returnUrl}
      subscriptionType={props.subscriptionType}
    />
  );
}

function FormButtons({ disabled, loading }) {
  return (
    <div className="modal-footer">
      <button
        className="btn btn-md btn-default form-submit-cancel"
        type="button"
        data-dismiss="modal"
      >
        Cancel
      </button>
      <button
        className="btn btn-md btn-primary form-submit"
        type="submit"
        data-text_submitting="Submitting..." // TODO: Is data-text_submitting still needed?
        data-text="Submit"
        disabled={disabled}
      >
        {loading ? "Submitting..." : "Submit"}
      </button>
    </div>
  );
}
